export  default {
    getCustomer(state) {
        return state.customer;
    },
    
};